import { useEffect, useMemo } from 'react';

import { Fit, Layout, useStateMachineInput } from '@rive-app/react-canvas';

import { useRiveMachine } from '../../../hooks/rive/useRiveMachine';
import { useFlag } from '../../../services/launchDarkly';
import { formatPlainNumber } from '../../../utils/numberFormat';

import classes from './ClaimPlinkoRiveAnimation.module.scss';

const STATE_MACHINE_NAME = 'State Machine 1';

interface ClaimPinkoRiveAnimationProps {
  input: 'yellow' | 'green';
  onAnimationEnd?: () => void;
  amount: number;
}

type RiveUrlsType = {
  url: string;
};

export function ClaimPlinkoRiveAnimation(props: ClaimPinkoRiveAnimationProps) {
  const { input, onAnimationEnd, amount } = props;

  const jsonUrl = useFlag<RiveUrlsType | null>('plinko_claim_animation_file_url', null);

  const url: string | null = useMemo(() => {
    if (jsonUrl) {
      return jsonUrl.url;
    }
    return null;
  }, [jsonUrl]);

  const { rive, RiveComponent } = useRiveMachine({
    src: url || '',
    stateMachineName: STATE_MACHINE_NAME,
    layout: new Layout({
      fit: Fit.Contain,
    }),
    onStateChange: (event) => {
      const data: string[] = event.data as string[];
      if (data && data.length && data[0] === 'animation_end') {
        if (onAnimationEnd) {
          onAnimationEnd();
        }
      }
    },
    autoplay: false,
  });

  const inputState = useStateMachineInput(rive, STATE_MACHINE_NAME, input, true);

  useEffect(() => {
    if (url) {
      inputState?.fire();
      rive?.setTextRunValue('amount', formatPlainNumber(amount));
      rive?.play();
    } else {
      onAnimationEnd?.();
    }
  }, [amount, inputState, onAnimationEnd, rive, url]);

  return <div className={classes.container}>{url && <RiveComponent />}</div>;
}
